import { render, staticRenderFns } from "./FieldsEdit.vue?vue&type=template&id=44ff4530&scoped=true"
import script from "./FieldsEdit.vue?vue&type=script&lang=ts"
export * from "./FieldsEdit.vue?vue&type=script&lang=ts"
import style0 from "./FieldsEdit.vue?vue&type=style&index=0&id=44ff4530&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44ff4530",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44ff4530')) {
      api.createRecord('44ff4530', component.options)
    } else {
      api.reload('44ff4530', component.options)
    }
    module.hot.accept("./FieldsEdit.vue?vue&type=template&id=44ff4530&scoped=true", function () {
      api.rerender('44ff4530', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sale-layout-editor/FieldsEdit.vue"
export default component.exports